const AiGenTip = () => {
    return <div className="my-3 text-center text-[#999]">内容由 Ai 生成，请仔细甄别</div>;
};

export default AiGenTip;
